import { render, staticRenderFns } from "./packInfo.vue?vue&type=template&id=a3c698a2"
import script from "./packInfo.vue?vue&type=script&lang=js"
export * from "./packInfo.vue?vue&type=script&lang=js"
import style0 from "./packInfo.vue?vue&type=style&index=0&id=a3c698a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports